import { Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { SimpleHorizontalFormControl } from '../../../../../../common/simpleComponents';
import React from 'react';

export const ReferenceField = ({ paymentType }) => {
  const displayFieldFor = ['account', 'cheque'];

  if (displayFieldFor.includes(paymentType)) {
    return (
      <div className="card-details">
        <Row>
          <Col sm={6}>
            <ControlLabel>Payment Reference</ControlLabel>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name={'meta.payment_reference'}
              component={SimpleHorizontalFormControl}
            />
          </Col>
        </Row>
      </div>
    );
  }

  return null;
};
